export const OperationChartData = [
  {
    data: [
      {
        gmap: {
          lat: "30.2672",
          lon: "-97.7431",
        },
        emission: [
          {
            notes: [],
            id: "dc69cf6a-d5fd-43ca-9e01-739fec34e048",
            source: "Flare",
            size: "Medium",
            description: "Test",
            picture: "how-to-take-group-photos-7.jpg",
            video: "sample-video.mp4",
            pictureFile: null,
            pictureID: "7faea011-9d42-4129-8cb1-99692d77f23b",
            videoID: "08637041-8d76-4acb-9fa6-e2c61e09eea3",
            videoFile: null,
            createdBy: "",
            updatedBy: "Tony Stark",
            createdOn: "2023-07-18T11:41:34.771Z",
            updatedOn: "2023-07-18T11:42:26.738Z",
            noOfLeaks: 1,
            leakPersistence: "Intermittent",
            userLocDateTime: "2023-07-18T11:40:38Z",
          },
        ],
        id: "281d017d-75a2-46df-ae2e-3240860a4a3a",
        type: "Tank_battery_non_satellite",
        name: "Austin Site",
        county: "John",
        state: "Texas",
        emissionCount: "1",
        fid: null,
        continuousEmission: false,
      },

      {
        gmap: {
          lat: "32.41542264",
          lon: "-103.8330246",
        },
        emission: [],
        id: "1fc0889f-9009-4ea9-a9a3-b14ed2b27b9a",
        type: "Production_site_with_tank",
        name: "BARNEY BEF FEDERAL 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 4,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.41551667",
          lon: "-104.0699667",
        },
        emission: [],
        id: "641c828e-152e-416e-8dc6-6b0219f30263",
        type: "Tank_battery_non_satellite",
        name: "BASS 3 FEDERAL",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 5,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.57",
          lon: "-103.852997",
        },
        emission: [],
        id: "18006aae-d031-4106-b3a2-3e622c21afe1",
        type: "SWD",
        name: "BEU 14 FED 1",
        county: "Harris",
        state: "Texas",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.40503118",
          lon: "-104.0863398",
        },
        emission: [],
        id: "b3e94e73-8055-42b1-96c4-a420b761ea34",
        type: "Production_site_with_tank",
        name: "BEU 159 BATTERY",
        county: "John",
        state: "Texas",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.45362731",
          lon: "-104.1204178",
        },
        emission: [],
        id: "658add5f-99ee-4e1c-b44b-eaf4bd4d9d37",
        type: "Tank_battery_non_satellite",
        name: "BEU EDDY 151WF",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.621766",
          lon: "-103.851289",
        },
        emission: [],
        id: "01a7d7b5-cbcb-4e25-87a1-95f523e1cc78",
        type: "SWD",
        name: "BEU HACKBERRY 34 SWD 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.49130687",
          lon: "-104.0086668",
        },
        emission: [],
        id: "a8034a38-5a22-4b1b-ad3a-3ccd69697045",
        type: "Compressor_station",
        name: "BEU NORTH CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.39440855",
          lon: "-104.0825263",
        },
        emission: [],
        id: "6c69e6b1-746c-49fe-abf1-950d913443d4",
        type: "Tank_battery_non_satellite",
        name: "BIG CHIEF COMM #005",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.55309122",
          lon: "-103.9067701",
        },
        emission: [],
        id: "cdb1912a-4155-4eea-abc3-4162b68ee945",
        type: "Production_site_with_tank",
        name: "BIG EDDY 007",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.43104345",
          lon: "-104.0942642",
        },
        emission: [],
        id: "898407e5-40e1-483f-a01e-8537ec311a2e",
        type: "Production_site_with_tank",
        name: "BIG EDDY 064",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.4490777",
          lon: "-104.0418459",
        },
        emission: [],
        id: "caa955a6-5d40-4f85-ac15-e4b017a89f25",
        type: "Production_site_with_tank",
        name: "BIG EDDY 066",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.45637489",
          lon: "-104.0547484",
        },
        emission: [],
        id: "a821b865-c976-4a6a-88c6-41be0329bb42",
        type: "Production_site_with_tank",
        name: "BIG EDDY 070S",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.49923709",
          lon: "-104.0085475",
        },
        emission: [],
        id: "7f291977-f584-495b-9b9c-70d63bab188a",
        type: "Production_site_with_tank",
        name: "BIG EDDY 073",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.45638537",
          lon: "-104.0377574",
        },
        emission: [],
        id: "c0cff0fd-7f35-4364-81eb-fe85646a2a4d",
        type: "Production_site_with_tank",
        name: "BIG EDDY 074D BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.48808151",
          lon: "-104.0091417",
        },
        emission: [],
        id: "75cd4b26-08bc-4b0b-8c74-9dfe2d854cfe",
        type: "Production_site_with_tank",
        name: "BIG EDDY 085",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.46647478",
          lon: "-104.0133011",
        },
        emission: [],
        id: "59595df3-a05d-49b4-8e3a-8923856d3813",
        type: "Production_site_with_tank",
        name: "BIG EDDY 094",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.44177122",
          lon: "-104.0893695",
        },
        emission: [],
        id: "cc1cc26f-0169-4e08-8796-08f70ecc8565",
        type: "Production_site_with_tank",
        name: "BIG EDDY 095",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.45196514",
          lon: "-103.9753915",
        },
        emission: [],
        id: "c1d96647-df54-4f04-8865-565463350ed1",
        type: "Production_site_with_tank",
        name: "BIG EDDY 133 BATTERY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.39794697",
          lon: "-104.0686313",
        },
        emission: [],
        id: "e5a4e4e5-ddd7-4f08-ac5b-195bf9dde554",
        type: "Production_site_with_tank",
        name: "BIG EDDY 154",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.49641046",
          lon: "-103.9955286",
        },
        emission: [],
        id: "f0c60a8f-ec08-4002-b130-9dc847e2edfd",
        type: "Production_site_with_tank",
        name: "BIG EDDY 163",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.50717815",
          lon: "-104.1104821",
        },
        emission: [],
        id: "d3c4c619-4ca9-4e14-91ac-982bf53c4196",
        type: "Production_site_with_tank",
        name: "BIG EDDY 165",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.47449291",
          lon: "-104.0897176",
        },
        emission: [],
        id: "22202ec2-8f56-4699-831c-295e99e5b567",
        type: "Production_site_with_tank",
        name: "BIG EDDY 168",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.43104345",
          lon: "-104.0942642",
        },
        emission: [],
        id: "becfd210-be8a-4f34-88c3-a8fdb4ee5f4d",
        type: "Production_site_with_tank",
        name: "Site A",
        county: "Harris",
        state: "Texas",
        emissionCount: "0",
        fid: 1,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.4490777",
          lon: "-104.0418459",
        },
        emission: [],
        id: "1dfa7cd8-85a5-4dc8-86a8-fbf0b6106092",
        type: "Tank_battery_non_satellite",
        name: "Site B",
        county: "John",
        state: "Texas",
        emissionCount: "0",
        fid: 2,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.39783401",
          lon: "-104.1167173",
        },
        emission: [],
        id: "5e20e260-801b-4855-b1d5-21e15cf96893",
        type: "Production_site_with_tank",
        name: "BIG EDDY 218",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.44696086",
          lon: "-104.1108088",
        },
        emission: [],
        id: "8ba3a4e9-ab27-40ab-af0e-e2b270594b10",
        type: "Production_site_with_tank",
        name: "BIG EDDY 54 BATTERY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.59673567",
          lon: "-103.8677943",
        },
        emission: [],
        id: "053c66e5-05cd-4250-98d0-8f3ed4392ac2",
        type: "Production_site_with_tank",
        name: "BIG EDDY BATT DI 33",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.45679991",
          lon: "-104.1325328",
        },
        emission: [],
        id: "77e30d5f-7ef2-4ad5-8531-8543c2fb27b1",
        type: "Production_site_with_tank",
        name: "BIG EDDY COM 144",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.47560144",
          lon: "-104.0553884",
        },
        emission: [],
        id: "548b5a23-f0a0-4b91-a39f-1dc859797a2a",
        type: "Production_site_with_tank",
        name: "BIG EDDY COM 167",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.6220564",
          lon: "-103.851442",
        },
        emission: [],
        id: "573076a1-1c9e-46a0-a4ac-33c11fe8c5ae",
        type: "Production_site_with_tank",
        name: "BIG EDDY HACKBERRY 34 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 6,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.44127284",
          lon: "-103.9749366",
        },
        emission: [],
        id: "c73d3f08-a482-472f-b4a8-cf51f0a06f01",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT #038H",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 7,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.43808559",
          lon: "-103.9576739",
        },
        emission: [],
        id: "136c110b-500d-4036-a91d-894e9e607fcc",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT #097",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 8,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.46077381",
          lon: "-104.1280634",
        },
        emission: [],
        id: "132c03b2-726f-4ab8-93b2-8d59d1c9384b",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT #143",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 9,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.36164772",
          lon: "-104.0476645",
        },
        emission: [],
        id: "eefe72d1-0b14-490b-9ef6-8ee057d5779c",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT #171",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 10,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.45316553",
          lon: "-104.1063355",
        },
        emission: [],
        id: "c14474bf-3b08-4d8c-86f9-a6bb2787bfba",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 039",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 11,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.49633408",
          lon: "-104.1061695",
        },
        emission: [],
        id: "cfe62093-be76-47ec-828a-cefd63a03951",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 053",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.46737148",
          lon: "-104.0546676",
        },
        emission: [],
        id: "f0197eb5-6cd8-4937-b465-c67eb09d4d11",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 076",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.40433657",
          lon: "-104.0952714",
        },
        emission: [],
        id: "a2a30403-5a08-4f4a-82c7-5f768a29255e",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 077",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.40536484",
          lon: "-104.0693244",
        },
        emission: [],
        id: "7cc437a2-8e88-4220-81f3-24ea5604baef",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 082",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 12,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.44910792",
          lon: "-104.0937559",
        },
        emission: [],
        id: "21506319-a9f7-4e25-ac8a-be925c6e1836",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 087",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 13,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.46605391",
          lon: "-103.9829138",
        },
        emission: [],
        id: "c3b861cd-3c59-40e4-bee9-9da5e62af334",
        type: "Tank_battery_non_satellite",
        name: "BIG EDDY UNIT 114",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 14,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.43817691",
          lon: "-104.1020053",
        },
        emission: [],
        id: "eef183b9-3a2e-42d2-b9cd-8dd0f1b36e42",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 149",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 15,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.47862509",
          lon: "-104.1111893",
        },
        emission: [],
        id: "64873d30-aa85-412e-8221-eb73bae082d9",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 150",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 16,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.45911437",
          lon: "-104.0049897",
        },
        emission: [],
        id: "6a9c5843-d861-4625-b1e0-680f338c4481",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 153",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 17,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.36850229",
          lon: "-104.0477727",
        },
        emission: [],
        id: "95ece438-8694-4314-9c0f-90eda7ddd7d2",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 155",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 18,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.41319267",
          lon: "-104.0643077",
        },
        emission: [],
        id: "e179b8fa-d3e5-4bff-b408-01b74539bfd9",
        type: "Tank_battery_non_satellite",
        name: "BIG EDDY UNIT 156",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 19,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.42006255",
          lon: "-104.0897733",
        },
        emission: [],
        id: "dc1a0593-cb5f-4439-aff2-e8e896a4ee07",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 158",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 20,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.41194387",
          lon: "-104.0785303",
        },
        emission: [],
        id: "5f39a300-c178-42a1-825d-bd417be371b0",
        type: "Tank_battery_non_satellite",
        name: "BIG EDDY UNIT 160",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 21,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.49543257",
          lon: "-104.0224053",
        },
        emission: [],
        id: "5de65885-cf8a-4529-aaef-b4f19ad6adee",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 162",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 22,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.44730412",
          lon: "-103.9690332",
        },
        emission: [],
        id: "b19376e9-e5cb-48ac-ab16-b85938690638",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 164",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 23,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.48536608",
          lon: "-104.1116673",
        },
        emission: [],
        id: "76f205b3-98f4-42f9-bc99-aa0eab0723b7",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 169",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.38770921",
          lon: "-104.0643386",
        },
        emission: [],
        id: "43ed114e-620c-4fc0-93c7-899a3d338070",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 186",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.41238905",
          lon: "-104.0986238",
        },
        emission: [],
        id: "57b34f8c-8473-4c7a-b442-687f47df6339",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 190",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.47374219",
          lon: "-104.0091568",
        },
        emission: [],
        id: "bd0fd045-0d92-4b92-a715-f3a834f8efec",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 191",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.46731381",
          lon: "-104.0468461",
        },
        emission: [],
        id: "dacf340e-095c-4e89-a0fe-d56291abb38e",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 202",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.4188261",
          lon: "-104.1157116",
        },
        emission: [],
        id: "f11c57b9-3f26-45e3-b7da-2cff45eef66d",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 213",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.48864752",
          lon: "-103.9871149",
        },
        emission: [],
        id: "f0dc10a3-8802-4648-83c4-a5c37a663713",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT 220",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.445841",
          lon: "-104.013808",
        },
        emission: [],
        id: "1726a1d8-02f4-4eff-aa76-df5027ca3cd0",
        type: "SWD",
        name: "BIG EDDY UNIT 29 FEDERAL SWD 1",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.41897081",
          lon: "-104.1242161",
        },
        emission: [],
        id: "80c947a1-358b-423c-985d-073d8a52c4f6",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT COM 148",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.48972816",
          lon: "-103.9875671",
        },
        emission: [],
        id: "5b37a56a-d6d3-4042-aa10-9fa4173aeaa8",
        type: "Tank_battery_non_satellite",
        name: "BIG EDDY UNIT DI 28 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.60835679",
          lon: "-103.8906625",
        },
        emission: [],
        id: "6759c879-08da-4e60-ab0b-cef045b4e79e",
        type: "Tank_battery_non_satellite",
        name: "BIG EDDY UNIT DI4 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.54477491",
          lon: "-103.8553998",
        },
        emission: [],
        id: "c28616cc-b5f0-4d44-b080-f698fc05beb1",
        type: "Tank_battery_non_satellite",
        name: "BIG EDDY UNIT DI5 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.45636974",
          lon: "-103.8790099",
        },
        emission: [],
        id: "a89a6667-ef7b-4353-a99a-30f7473b6c3c",
        type: "Tank_battery_non_satellite",
        name: "BIG EDDY UNIT DI9 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.50720615",
          lon: "-104.0724433",
        },
        emission: [],
        id: "453da666-ef58-4951-b8a3-b9909fc59e88",
        type: "Production_site_with_tank",
        name: "BIG EDDY UNIT MASTER 72",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.24849553",
          lon: "-103.859583",
        },
        emission: [],
        id: "a509c35e-ad8b-4b6c-96fd-7503b490b207",
        type: "Production_site_with_tank",
        name: "BIG SINKS 02 24 30 ST BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.12289935",
          lon: "-103.9695583",
        },
        emission: [],
        id: "04304387-2814-4ad0-ba0e-48e195ea8601",
        type: "Production_site_with_tank",
        name: "BLACKBART TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.29228821",
          lon: "-103.9273886",
        },
        emission: [],
        id: "43adcd19-422f-4404-ab73-1be7df724742",
        type: "Compressor_station",
        name: "BRONCO CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.64127431",
          lon: "-103.9638609",
        },
        emission: [],
        id: "3ac28c34-0573-4dd5-b522-8c61d3f1cda9",
        type: "Tank_battery_non_satellite",
        name: "BUBBLES TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.55680056",
          lon: "-103.8551892",
        },
        emission: [],
        id: "7121b18f-8c5c-485f-b503-63caaaa05e9c",
        type: "Compressor_station",
        name: "BULLDOG CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.51761672",
          lon: "-103.7030918",
        },
        emission: [],
        id: "abba343a-f94c-47df-9f9a-5a58c8b041b5",
        type: "Production_site_with_tank",
        name: "C.A. LOOMIS FED MASTER 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.53398833",
          lon: "-103.6841237",
        },
        emission: [],
        id: "1f77bce1-0dc4-4fe3-92a3-9cf5e8abe3c4",
        type: "Tank_battery_non_satellite",
        name: "CHISTERA TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.12104438",
          lon: "-103.9079105",
        },
        emission: [],
        id: "1fa1dff4-41cc-4b89-b781-fe81aeab5b14",
        type: "Tank_battery_non_satellite",
        name: "CONTINENTAL FED 1",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.14773238",
          lon: "-103.9785033",
        },
        emission: [],
        id: "3a5feb8e-d142-4121-8ad1-75ea766139eb",
        type: "Tank_battery_non_satellite",
        name: "CORRAL CANYON 10 EAST TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15056599",
          lon: "-103.9707967",
        },
        emission: [],
        id: "5f5102d0-dcb3-432c-a6df-1c1452a8c5e0",
        type: "Tank_battery_non_satellite",
        name: "CORRAL CANYON 10 TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15254157",
          lon: "-103.9990167",
        },
        emission: [],
        id: "6a5b9078-f0bc-4869-91db-a35cf7b1d9dc",
        type: "Tank_battery_non_satellite",
        name: "CORRAL CANYON CTB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.135101",
          lon: "-103.994003",
        },
        emission: [],
        id: "df97b0ff-c50a-432f-b8ba-cf13eedd819e",
        type: "SWD",
        name: "CORRAL CANYON STATE 16 SWD",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15992455",
          lon: "-103.8415768",
        },
        emission: [],
        id: "c27fd706-fefd-45ca-9c7b-7baabe99a5fe",
        type: "CDP",
        name: "COWBOY CDP",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.20808855",
          lon: "-103.8532268",
        },
        emission: [],
        id: "2c7d9a0f-e96b-4c67-92ea-69eb8452f5a9",
        type: "Tank_battery_non_satellite",
        name: "DELAWARE B",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.368777",
          lon: "-103.867356",
        },
        emission: [],
        id: "60bde873-d947-4eaf-8f34-31eef1ad3e6a",
        type: "SWD",
        name: "DEVON LEGG",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.37291675",
          lon: "-103.8267416",
        },
        emission: [],
        id: "4d093a67-5397-41be-9430-eb52f021cf93",
        type: "Production_site_with_tank",
        name: "DI DOS BATTERY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.08510167",
          lon: "-103.9386912",
        },
        emission: [],
        id: "4984748b-e3d0-420e-b337-997a64a0a06c",
        type: "Production_site_with_tank",
        name: "DRAW BJL STATE #1 BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.14570778",
          lon: "-103.963176",
        },
        emission: [],
        id: "4ebd7849-446a-490b-8e9f-5c0383fe3398",
        type: "CDP",
        name: "ELK WALLOW CDP",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.51708202",
          lon: "-104.2013562",
        },
        emission: [],
        id: "33dd4fa7-7959-47e3-aa7e-bae9b104517a",
        type: "Production_site_with_tank",
        name: "FULL YATES C FED #19 (B6248)",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.50686771",
          lon: "-104.2107972",
        },
        emission: [],
        id: "b8242905-3857-428d-b501-ecb49f743033",
        type: "Tank_battery_non_satellite",
        name: "FULL YATES C FED #31 (B6569)",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.5534803",
          lon: "-103.8473075",
        },
        emission: [],
        id: "a7f4536f-e5ed-44d2-8f2b-414d0c8bdedd",
        type: "Tank_battery_non_satellite",
        name: "GH COBB FEDERAL 1 BATTERY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15437949",
          lon: "-104.0163551",
        },
        emission: [],
        id: "4847fec7-3a7b-4beb-8358-4534dc5ad402",
        type: "Tank_battery_non_satellite",
        name: "GOLDEN CHILD CTB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15083929",
          lon: "-104.0162348",
        },
        emission: [],
        id: "e5f8fd90-bd2c-40b4-af5b-e9c36d510840",
        type: "Tank_battery_non_satellite",
        name: "GOLDEN CORRAL 6 STATE 1H BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.1544",
          lon: "-104.015999",
        },
        emission: [],
        id: "79ca1d19-bd6c-4c38-a35f-cd3e29f7ec6a",
        type: "SWD",
        name: "GOLDENCHILD 6 STATE 1 SWD",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.623457",
          lon: "-103.853001",
        },
        emission: [],
        id: "d9f28b63-3d3d-4475-8814-03016bceba5f",
        type: "CDP",
        name: "HACKBERRY OIL CDP",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.60843741",
          lon: "-103.9089906",
        },
        emission: [],
        id: "63af514b-4e4b-4b13-9836-515251b4ea97",
        type: "Production_site_with_tank",
        name: "HASTA LA VISTA 1DI1 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.49852231",
          lon: "-103.6691831",
        },
        emission: [],
        id: "a1bf29ac-0e6a-4000-a6ec-5e58dd9433c5",
        type: "Production_site_with_tank",
        name: "HAT MESA 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.53477744",
          lon: "-103.700738",
        },
        emission: [],
        id: "f037215e-572a-4006-8fa9-42a26b1464b1",
        type: "Tank_battery_non_satellite",
        name: "HAT MESA '31' STATE BATT 1_2",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.33614461",
          lon: "-103.8367278",
        },
        emission: [],
        id: "c1c8e6ef-b276-4951-b749-316ccdde16e7",
        type: "Production_site_with_tank",
        name: "HUDSON 1 FEDERAL BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.40882994",
          lon: "-104.1285435",
        },
        emission: [],
        id: "25145feb-b6ae-4e37-ae52-19904b4eff13",
        type: "Production_site_with_tank",
        name: "INDIAN DRAW DEEP 7 COM001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.41197",
          lon: "-104.12074",
        },
        emission: [],
        id: "07201790-7a1b-49d3-9a61-f3e0190eb0b3",
        type: "Production_site_with_tank",
        name: "INDIAN DRAW DEEP 7 COM003",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.4339659203",
          lon: "-104.055244559",
        },
        emission: [],
        id: "2abd59be-5b55-46dc-8395-5b498ebd737c",
        type: "SWD",
        name: "INDIAN FLATS BASS FED SWD",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.43395555",
          lon: "-104.0554736",
        },
        emission: [],
        id: "b57bf343-a9b3-46da-8089-a35e7a9e66fd",
        type: "Tank_battery_non_satellite",
        name: "INDIAN FLTS BASS FED BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15045744",
          lon: "-103.8409884",
        },
        emission: [],
        id: "63ef6269-443c-46fc-a231-a18e1beaa633",
        type: "Tank_battery_non_satellite",
        name: "J.F. HARRISON001 SWD",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.3467689939",
          lon: "-103.8359199744",
        },
        emission: [],
        id: "d4d61162-42e8-466e-9957-94406d0cd57a",
        type: "SWD",
        name: "JAMES RANCH 29",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.28319137",
          lon: "-103.7724915",
        },
        emission: [],
        id: "fc7dbdcf-f95e-4606-9031-f2e029e3b3a2",
        type: "Tank_battery_non_satellite",
        name: "JAMES RANCH BOOSTER STATION",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.33184824",
          lon: "-103.8305536",
        },
        emission: [],
        id: "ecb226cb-b61d-4d88-9d02-ffc1956fd17f",
        type: "Production_site_with_tank",
        name: "JAMES RANCH UNIT 003",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.33554489",
          lon: "-103.8275487",
        },
        emission: [],
        id: "760fa7b6-e8be-4c4e-a2bb-3ea368100ef3",
        type: "Production_site_with_tank",
        name: "JAMES RANCH UNIT 010",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.33637877",
          lon: "-103.8227809",
        },
        emission: [],
        id: "fe7f7c7d-0156-45d5-91bc-df3fefd1fa1f",
        type: "Tank_battery_non_satellite",
        name: "JAMES RANCH UNIT 013",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.31336941",
          lon: "-103.8084338",
        },
        emission: [],
        id: "e8f5102a-cafa-4b05-b781-f35577f58f41",
        type: "Production_site_with_tank",
        name: "JAMES RANCH UNIT 015-S",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.30501228",
          lon: "-103.8027711",
        },
        emission: [],
        id: "acc08546-1bf3-456b-a7d4-9976059bdf3e",
        type: "Production_site_with_tank",
        name: "JAMES RANCH UNIT 124 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.32622938",
          lon: "-103.8194823",
        },
        emission: [],
        id: "33250b17-87be-491f-a6b0-c0b4e02ac777",
        type: "Production_site_with_tank",
        name: "JAMES RANCH UNIT 14",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.368777",
          lon: "-103.867356",
        },
        emission: [],
        id: "a4eb489f-17a1-43d9-ad8f-2a91f2521bc4",
        type: "SWD",
        name: "JAMES RANCH UNIT 21 FEDERAL SWD 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.34650508",
          lon: "-103.8356962",
        },
        emission: [],
        id: "e6e647db-67ae-4410-a868-3e8991bd572d",
        type: "Production_site_with_tank",
        name: "JAMES RANCH UNIT 29 SWD",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.3512",
          lon: "-103.834",
        },
        emission: [],
        id: "d7a1342d-98a6-47b1-8d25-c01f125f1a5d",
        type: "SWD",
        name: "JAMES RANCH UNIT 36 RAMBLER ST SWD 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.333106",
          lon: "-103.823097",
        },
        emission: [],
        id: "dd38f5cc-84d4-44c9-a316-23d47d42001d",
        type: "SWD",
        name: "JAMES RANCH UNIT 6 TORINO FEE SWD 1",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.33199771",
          lon: "-103.825987",
        },
        emission: [],
        id: "d4fcad18-4505-4e41-b2dd-06d7c3c7d368",
        type: "Tank_battery_non_satellite",
        name: "JAMES RANCH UNIT BATT 004",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.33497389",
          lon: "-103.8145955",
        },
        emission: [],
        id: "b4815b16-022f-411a-8d38-79288101207b",
        type: "Production_site_with_tank",
        name: "JAMES RANCH UNIT BATT 007",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.33539775",
          lon: "-103.8192134",
        },
        emission: [],
        id: "b209d7e2-e7e2-4c37-b937-a3b8f37012e9",
        type: "Production_site_with_tank",
        name: "JAMES RANCH UNIT BATT 017",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.3467",
          lon: "-103.8321",
        },
        emission: [],
        id: "71709bfb-e0ad-417c-8f81-44b3a2a7cc84",
        type: "Production_site_with_tank",
        name: "JAMES RANCH UNIT BATT 019",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.335875",
          lon: "-103.8318361",
        },
        emission: [],
        id: "d7125482-1d12-4b33-baea-6392d88522e9",
        type: "Tank_battery_non_satellite",
        name: "JAMES RANCH UNIT BATT 036",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.34286646",
          lon: "-103.8323239",
        },
        emission: [],
        id: "1f8db383-46a3-42a2-9a5f-6d83bb779b25",
        type: "Production_site_with_tank",
        name: "JRU 1",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.35027159",
          lon: "-103.8294968",
        },
        emission: [],
        id: "a1b2845d-58fa-4207-a940-ff90f5b4c96d",
        type: "Production_site_with_tank",
        name: "JRU 18",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.40230175",
          lon: "-103.8420083",
        },
        emission: [],
        id: "20f170ed-a24f-4394-8113-da9e8adc7c91",
        type: "Tank_battery_non_satellite",
        name: "JRU 48",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.30615551",
          lon: "-103.8022647",
        },
        emission: [],
        id: "64470cad-ace4-41dd-9986-4239fc9e8e4e",
        type: "Production_site_with_tank",
        name: "JRU 5",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.40093147",
          lon: "-103.8317716",
        },
        emission: [],
        id: "0e0508cf-43f8-49f9-8ef5-405b9078c798",
        type: "Tank_battery_non_satellite",
        name: "JRU 70",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.36308096",
          lon: "-103.8376598",
        },
        emission: [],
        id: "baebf928-dbbf-4ec2-9aa4-5ae7f1825e1b",
        type: "Tank_battery_non_satellite",
        name: "JRU DI 2 BATTERY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.37987506",
          lon: "-103.8867582",
        },
        emission: [],
        id: "354e5d75-ae6d-40e0-a968-8cb71ce05af8",
        type: "Tank_battery_non_satellite",
        name: "JRU DI1A",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.34939691",
          lon: "-103.8417616",
        },
        emission: [],
        id: "d51ee23c-c8ae-4a39-b3af-c68e6889f1ef",
        type: "Production_site_with_tank",
        name: "JRU DI8",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.36847026",
          lon: "-103.8676429",
        },
        emission: [],
        id: "b914cf03-7b59-4dc4-a42a-936ebd130e34",
        type: "Tank_battery_non_satellite",
        name: "LEG FEDERAL",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.36759081",
          lon: "-103.8665774",
        },
        emission: [],
        id: "cfefdce5-3c22-4c36-a54a-b334d5614881",
        type: "Compressor_station",
        name: "LEGG CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.38110089",
          lon: "-103.8835227",
        },
        emission: [],
        id: "9260c4e3-284f-4d1a-8058-6cf6de036574",
        type: "Production_site_with_tank",
        name: "LEGG SWD FEDERAL BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.3669297",
          lon: "-103.8659786",
        },
        emission: [],
        id: "d7fab13c-f4ae-47b7-998f-c974dda1a97f",
        type: "CDP",
        name: "LONGHORN CDP",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.37275268",
          lon: "-103.8567681",
        },
        emission: [],
        id: "8681fabe-4daf-4c52-b49e-5ccb0f35f0bf",
        type: "Compressor_station",
        name: "LONGHORN CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.258452",
          lon: "-103.836256",
        },
        emission: [],
        id: "fecc6c3c-0fbb-4452-bf4d-6a681ea985c3",
        type: "Compressor_station",
        name: "LOS DOS MEDANOS CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.25903122",
          lon: "-103.8370912",
        },
        emission: [],
        id: "b8a2c732-b95a-4c47-92bf-e5d053f3397b",
        type: "Tank_battery_non_satellite",
        name: "LOS DOS MEDANOS TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.25427651",
          lon: "-103.8407392",
        },
        emission: [],
        id: "b702e025-4156-4c20-bdce-593aaf3ba6d1",
        type: "Tank_battery_non_satellite",
        name: "LOS MEDANOS 36 23 20 STATE BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.11159985",
          lon: "-103.8051885",
        },
        emission: [],
        id: "b4605c68-8b58-49be-b27b-dd38de186e8c",
        type: "Compressor_station",
        name: "MAVERICK CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.69180766",
          lon: "-104.1237175",
        },
        emission: [],
        id: "a36ef249-a432-4fb1-9d8c-e82dc9b87e13",
        type: "Production_site_with_tank",
        name: "MERCHANT STATE 1",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.1104097",
          lon: "-103.9659528",
        },
        emission: [],
        id: "6d3966d8-9bcf-47e2-8c25-48a4f03c7837",
        type: "Tank_battery_non_satellite",
        name: "MESCAL 22 FED 2H TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.12165545",
          lon: "-103.9639835",
        },
        emission: [],
        id: "0f1198de-b4bd-4491-bdc4-f45d64cc1203",
        type: "Production_site_with_tank",
        name: "MESCAL 22 FED 3H SB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.2546618",
          lon: "-103.6087436",
        },
        emission: [],
        id: "ce34303f-e237-44aa-8a2d-5025711878ac",
        type: "Production_site_with_tank",
        name: "MIS AMIGOS BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.12720607",
          lon: "-103.9273813",
        },
        emission: [],
        id: "a8488f6d-1920-49ec-a655-b9e7f8be4d60",
        type: "Tank_battery_non_satellite",
        name: "MUY WAYNO 18",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15088136",
          lon: "-103.9226625",
        },
        emission: [],
        id: "f9a7157a-8b03-4477-bc71-1d5d788e2ed0",
        type: "Tank_battery_non_satellite",
        name: "MUY WAYNO STATE 7 BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.31641216",
          lon: "-103.9394787",
        },
        emission: [],
        id: "e5a04676-a209-42a3-b9a5-1200116f2ff1",
        type: "Production_site_with_tank",
        name: "NASH 052/053 CTB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.30013449",
          lon: "-103.9141437",
        },
        emission: [],
        id: "ea5c00ba-5af4-4d13-a857-8f1fed3d52e3",
        type: "Tank_battery_non_satellite",
        name: "NASH DEEP EAST TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.23157622",
          lon: "-103.9101615",
        },
        emission: [],
        id: "2417bbc0-e744-4f29-86e3-7c97325dbf06",
        type: "Tank_battery_non_satellite",
        name: "NASH DRAW 8",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.231576",
          lon: "-103.910161",
        },
        emission: [],
        id: "f883f546-418d-4594-9d6e-e2d4c4126a42",
        type: "SWD",
        name: "NASH DRAW 8 FEDERAL001H SWD",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.3093341992",
          lon: "-103.93085362",
        },
        emission: [],
        id: "dbdc2021-704f-41c1-8c4c-517564114cd5",
        type: "SWD",
        name: "NASH UNIT 04/053SWD",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.31910833",
          lon: "-103.9411553",
        },
        emission: [],
        id: "1d1ed532-937e-4650-b8cb-d1d44f940b78",
        type: "Production_site_with_tank",
        name: "NASH UNIT 39H BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.30651667",
          lon: "-103.9280472",
        },
        emission: [],
        id: "ec418384-3b71-4053-bdf0-d1151a51a56b",
        type: "Production_site_with_tank",
        name: "NASH UNIT 42H BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.30226667",
          lon: "-103.9483889",
        },
        emission: [],
        id: "8dcc9bf0-be7b-48bf-9fc8-cb081dcf90f6",
        type: "Production_site_with_tank",
        name: "NASH UNIT 56 BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.50826458",
          lon: "-103.6649706",
        },
        emission: [],
        id: "b98d1ea0-dc77-4843-81f4-7ceefd7ce3b9",
        type: "Tank_battery_non_satellite",
        name: "NEW MEX B FED BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.50956986",
          lon: "-103.6909173",
        },
        emission: [],
        id: "9c1ac3e1-422a-49ba-93a8-9385e10ca722",
        type: "Tank_battery_non_satellite",
        name: "NEW MEX E FED BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.67739891",
          lon: "-104.1285899",
        },
        emission: [],
        id: "ee237eb3-5356-4a4c-b9e9-ff278e439200",
        type: "Tank_battery_non_satellite",
        name: "NM O STATE COM",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.19492361",
          lon: "-103.679559",
        },
        emission: [],
        id: "14d33c97-3f03-432b-b8ef-240d843a392e",
        type: "Tank_battery_non_satellite",
        name: "OUTRIDER FED CTB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.11983426",
          lon: "-103.9616572",
        },
        emission: [],
        id: "87531b97-abc8-4a46-bc92-aa0f7e925290",
        type: "Tank_battery_non_satellite",
        name: "PATRON 23 FED 1H TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.63914243",
          lon: "-103.5212078",
        },
        emission: [],
        id: "77f49667-f9e5-4a0a-953a-811f3559c118",
        type: "Production_site_with_tank",
        name: "PERLA NEGRA BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.610667",
          lon: "-103.497139",
        },
        emission: [],
        id: "26370df9-9938-4a98-8377-7d764012f16c",
        type: "Tank_battery_non_satellite",
        name: "PERLA VERDE 31 STATE BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15480878",
          lon: "-103.8643763",
        },
        emission: [],
        id: "1fcf9ba2-0451-4c0c-ba1f-64f8cedba7b2",
        type: "Production_site_with_tank",
        name: "PIERCE CANYON 3",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.19670995",
          lon: "-103.7794619",
        },
        emission: [],
        id: "ec36e833-f828-47f9-9adb-2a89972a28a8",
        type: "CDP",
        name: "PLAINS CDP",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.20592259",
          lon: "-103.83032322",
        },
        emission: [],
        id: "41d26838-18f5-4a68-8ccf-8c5665f65a57",
        type: "Production_site_with_tank",
        name: "PLU 13 Dog Town Draw East",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.20599333",
          lon: "-103.83636758",
        },
        emission: [],
        id: "d7f44a0d-fc76-4295-8913-181ccca8012c",
        type: "Production_site_with_tank",
        name: "PLU 13 Dog Town Draw West",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.20927773",
          lon: "-103.7701166",
        },
        emission: [],
        id: "393d9f1a-bb1f-4622-991c-5138e8f98a65",
        type: "Tank_battery_non_satellite",
        name: "PLU 15 TWIN WELLS RANCH WEST SB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.1333",
          lon: "-103.9278",
        },
        emission: [],
        id: "dac15fcc-e2e9-4128-bdb4-acce58b1963d",
        type: "Tank_battery_non_satellite",
        name: "PLU 18 BRUSHY DRAW",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.2059498",
          lon: "-103.81235362",
        },
        emission: [],
        id: "b3d3cc6c-d2bf-4585-877d-c620e5059887",
        type: "Production_site_with_tank",
        name: "PLU 18 Twin Wells Ranch East",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.20609862",
          lon: "-103.8239015",
        },
        emission: [],
        id: "1f2bab2e-a6fb-44b3-be74-4ee2745ab5e6",
        type: "Production_site_with_tank",
        name: "PLU 18 Twin Wells Ranch West",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.11144774",
          lon: "-103.89628098",
        },
        emission: [],
        id: "63a86f44-3512-40c3-8849-82a8311cd9f3",
        type: "Production_site_with_tank",
        name: "PLU 20 Brushy Draw East",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.11164614",
          lon: "-103.90779575",
        },
        emission: [],
        id: "fbcd6783-18d1-44bc-955b-e157d4678468",
        type: "Production_site_with_tank",
        name: "PLU 20 Brushy Draw West",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.109418",
          lon: "-103.88191",
        },
        emission: [],
        id: "cfdaba97-11cc-446a-87ed-87a805d18b7b",
        type: "SWD",
        name: "PLU 21 LINCOLN FED SWD 1",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.212428",
          lon: "-103.913889",
        },
        emission: [],
        id: "13dcbd82-cd5d-4fa6-8543-d5608c58d9de",
        type: "SWD",
        name: "PLU 213 / NASH DRAW 19 FEDERAL SWD 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.10437236",
          lon: "-103.8304429",
        },
        emission: [],
        id: "8085fb93-de08-4589-b180-ede7a3b20468",
        type: "Tank_battery_non_satellite",
        name: "PLU 25 BRUSHY DRAW EAST SB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.10429069",
          lon: "-103.8390031",
        },
        emission: [],
        id: "fd959681-2ac4-4633-b2c2-27aa8f354243",
        type: "Tank_battery_non_satellite",
        name: "PLU 25 BRUSHY DRAW WEST TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.1044846",
          lon: "-103.77717199",
        },
        emission: [],
        id: "4d20711b-01c2-4d2d-9f24-ee1c1cdc954d",
        type: "Production_site_with_tank",
        name: "PLU 28 BIG SINKS EAST SB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.1043591",
          lon: "-103.78638584",
        },
        emission: [],
        id: "381353a3-596d-45c6-89f6-ecb4eddc20e8",
        type: "Production_site_with_tank",
        name: "PLU 28 BIG SINKS WEST TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.10441637",
          lon: "-103.79580719",
        },
        emission: [],
        id: "e147a636-d0ba-47a1-8c5f-d180aa4afada",
        type: "Production_site_with_tank",
        name: "PLU 29 BIG SINKS EAST SB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.10445994",
          lon: "-103.80210491",
        },
        emission: [],
        id: "0b1a9f5e-bd08-416b-ba91-ddc656141e9d",
        type: "Production_site_with_tank",
        name: "PLU 29 BIG SINKS WEST TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.254811",
          lon: "-103.907471",
        },
        emission: [],
        id: "df908fd7-ea14-48f0-91b6-daa67d3f2fb9",
        type: "SWD",
        name: "PLU 32 PLATY STATE SWD #001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.25481101",
          lon: "-103.9074707",
        },
        emission: [],
        id: "05a88fbe-d62e-47ad-b61a-85d786c96144",
        type: "Production_site_with_tank",
        name: "PLU 32 PLATY STATE SWD 1 TANK BATTERY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.179699",
          lon: "-103.828003",
        },
        emission: [],
        id: "50e32e49-87de-4746-a348-4552c159519a",
        type: "SWD",
        name: "PLU 36 DTD STATE SWD #001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.21921383",
          lon: "-103.9085647",
        },
        emission: [],
        id: "781dfefd-6ff1-4b51-8f24-11f1bdfefa62",
        type: "Production_site_with_tank",
        name: "PLU 49",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15332015",
          lon: "-103.8491097",
        },
        emission: [],
        id: "f7276c66-b1e6-4ee3-abfb-42c9adc57e77",
        type: "Production_site_with_tank",
        name: "PLU BIG SINKS 02 25 30 STATE BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15288192",
          lon: "-103.867519",
        },
        emission: [],
        id: "5f153670-5317-4ce5-8368-3b0467055c94",
        type: "Production_site_with_tank",
        name: "PLU BIG SINKS 03 25 30 USA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.152",
          lon: "-103.8193",
        },
        emission: [],
        id: "826d9ec1-13ce-451b-bbef-141d55ff5b64",
        type: "Tank_battery_non_satellite",
        name: "PLU BIG SINKS 07 25 31 USA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.2259",
          lon: "-103.8471",
        },
        emission: [],
        id: "7cae0a83-1613-4a68-857b-42e9d06aa3ab",
        type: "Tank_battery_non_satellite",
        name: "PLU BIG SINKS 11 FED BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.12438616",
          lon: "-103.8538569",
        },
        emission: [],
        id: "fb0f9966-d209-41f4-af27-78f50c5e0d2f",
        type: "Production_site_with_tank",
        name: "PLU BIG SINKS 14 25 30 USA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.21004268",
          lon: "-103.8193127",
        },
        emission: [],
        id: "ac69af2f-5ae1-4d33-8cc7-1b4e725b92e0",
        type: "Production_site_with_tank",
        name: "PLU BIG SINKS 19 24 31 USA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.19619417",
          lon: "-103.8617695",
        },
        emission: [],
        id: "d9c8bc20-f0f7-4b80-bf1c-8ac91fc7094c",
        type: "Tank_battery_non_satellite",
        name: "PLU BIG SINKS 22 FEDERAL BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.20906364",
          lon: "-103.8464988",
        },
        emission: [],
        id: "00765851-9db9-437a-9e02-93453ace6f95",
        type: "Production_site_with_tank",
        name: "PLU BIG SINKS 23 TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.18145807",
          lon: "-103.8330985",
        },
        emission: [],
        id: "12c465b3-3cc0-46f9-a455-faf9ea25bbfd",
        type: "Tank_battery_non_satellite",
        name: "PLU BIG SINKS 25 FEDERAL BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.16463277",
          lon: "-103.7772103",
        },
        emission: [],
        id: "fe67c81a-bf79-41b1-b529-6627d4bee38d",
        type: "Tank_battery_non_satellite",
        name: "PLU BIG SINKS 3 25 31 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.208089",
          lon: "-103.853227",
        },
        emission: [],
        id: "5b29c1e4-2608-4099-acf9-7c4eec5247ba",
        type: "SWD",
        name: "PLU DELAWARE B 23 FEDERAL SWD 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.06544086",
          lon: "-103.8330111",
        },
        emission: [],
        id: "f3e4a3dd-ff7e-4a07-be7a-ba7f427d689d",
        type: "Tank_battery_non_satellite",
        name: "PLU PHANTOM BANKS 01 FEDERAL BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.0658864",
          lon: "-103.7846176",
        },
        emission: [],
        id: "d184e3f5-4c88-4b11-8de4-965ea08da7ba",
        type: "Tank_battery_non_satellite",
        name: "PLU PHANTOM BANKS 04-26-31 USA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.12302256",
          lon: "-103.8064874",
        },
        emission: [],
        id: "1a9820d4-f204-4f4e-bd8d-f895b3f82ca2",
        type: "Production_site_with_tank",
        name: "PLU PHANTOM BANKS 20 25 31 USA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.09431668",
          lon: "-103.8355011",
        },
        emission: [],
        id: "87703979-36a9-4423-9ffb-68f17a3ae7a5",
        type: "Production_site_with_tank",
        name: "PLU PHANTOM BANKS 25-25-30 USA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.22538507",
          lon: "-103.9306427",
        },
        emission: [],
        id: "b07db218-5e63-41e4-a956-b3e207c229ec",
        type: "Production_site_with_tank",
        name: "PLU PIERCE CANYON 12 FEDERAL BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.21093148",
          lon: "-103.8839159",
        },
        emission: [],
        id: "72f85880-ee57-4a24-9a33-47ffe69ec9a5",
        type: "Tank_battery_non_satellite",
        name: "PLU PIERCE CANYON 16 24 30 STA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.12410336",
          lon: "-103.8790769",
        },
        emission: [],
        id: "935739fd-d2e2-471e-ab16-0f49b6e9b86a",
        type: "Tank_battery_non_satellite",
        name: "PLU PIERCE CANYON 16 STATE BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.124",
          lon: "-103.8959",
        },
        emission: [],
        id: "811cb78b-68a3-4f07-8f42-1b434c78d096",
        type: "Production_site_with_tank",
        name: "PLU PIERCE CANYON 17 FED BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.1262131758",
          lon: "-103.904518708",
        },
        emission: [],
        id: "6fa6ebdb-a2af-4151-91a9-18836e287cec",
        type: "SWD",
        name: "PLU PIERCE CANYON 17 FED SWD",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.21037507",
          lon: "-103.9004806",
        },
        emission: [],
        id: "266f4b12-2dc1-46e6-8cfd-5ff6f9ea3611",
        type: "Production_site_with_tank",
        name: "PLU PIERCE CANYON 20 24 30 USA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.18236462",
          lon: "-103.8802643",
        },
        emission: [],
        id: "7869c117-36fb-40d4-81b0-0a0c205cd0ca",
        type: "Production_site_with_tank",
        name: "PLU PIERCE CANYON 28 FEDERAL BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.154809",
          lon: "-103.864376",
        },
        emission: [],
        id: "b1f1a02e-f021-40a7-8605-564aabeadcda",
        type: "SWD",
        name: "PLU PIERCE CANYON 3 FEDERAL SWD001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.16767145",
          lon: "-103.8963649",
        },
        emission: [],
        id: "062d1c41-3a6a-4b7e-b32b-c75b1f8d3f30",
        type: "Tank_battery_non_satellite",
        name: "PLU PIERCE CANYON 32 STATE BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.16818277",
          lon: "-103.8782916",
        },
        emission: [],
        id: "b9441931-15ee-4da2-a0f9-5c06063fd0d5",
        type: "Production_site_with_tank",
        name: "PLU PIERCE CANYON 33 FEDERAL BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.25320898",
          lon: "-103.8815206",
        },
        emission: [],
        id: "32b45187-e787-44da-aea4-074b4ee3a06d",
        type: "Production_site_with_tank",
        name: "PLU REMUDA BASIN 04-24-30 USA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.2544",
          lon: "-103.91",
        },
        emission: [],
        id: "7a56cbf5-8e53-4386-8799-4f5d393313a3",
        type: "Production_site_with_tank",
        name: "PLU REMUDA BASIN 32 23 30 ST BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.10810318",
          lon: "-103.9135678",
        },
        emission: [],
        id: "78e0eea2-9c3f-4a0e-a4ff-f6b78ce08aab",
        type: "Production_site_with_tank",
        name: "PLU ROSS RANCH 19 FEDERAL BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.0933",
          lon: "-103.8926",
        },
        emission: [],
        id: "66d64911-ee57-4965-9c2b-92de9d633443",
        type: "Production_site_with_tank",
        name: "PLU ROSS RANCH 33 25 30 USA BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.19733157",
          lon: "-103.7893784",
        },
        emission: [],
        id: "5bbd699e-cfaa-4d23-97ed-8bf06f167584",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE 43",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.19388",
          lon: "-103.827563",
        },
        emission: [],
        id: "67d76080-4643-4b97-b448-324aea83501d",
        type: "SWD",
        name: "POKER LAKE 78 SWD",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.09170536",
          lon: "-103.785598",
        },
        emission: [],
        id: "f762106f-7ee1-4b6e-a553-6792a239fdb9",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT #057",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.18331828",
          lon: "-103.7855758",
        },
        emission: [],
        id: "cdbd4357-3a9d-4a38-8e31-e62e5c0e553d",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT #199",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.16499627",
          lon: "-103.7810659",
        },
        emission: [],
        id: "2909ceee-ce74-4fe5-a9e0-9c3abaabfffa",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 050",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.09470701",
          lon: "-103.7854327",
        },
        emission: [],
        id: "b7fdf862-0f66-4188-80f8-45dc3d12cb53",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT 052",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15050407",
          lon: "-103.7810069",
        },
        emission: [],
        id: "ed402a1a-d43d-4c17-883a-bed55d116e56",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 053",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.22673329",
          lon: "-103.9056467",
        },
        emission: [],
        id: "edae3724-16e5-4ad3-9a26-0061e7cbd712",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT 059",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15721666",
          lon: "-103.7679874",
        },
        emission: [],
        id: "d8641d7c-ae11-433e-b341-2899551bec1f",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 067A",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.26323634",
          lon: "-103.9108404",
        },
        emission: [],
        id: "964d6884-0439-4d58-8864-a9ee0f108f49",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT 140",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.1647767",
          lon: "-103.7966398",
        },
        emission: [],
        id: "d850755f-f1cd-42bd-871e-d981510d0ae3",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT 147",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.17672294",
          lon: "-103.7939152",
        },
        emission: [],
        id: "19f995cb-07a6-4bed-85cb-fee8ffc082d5",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 148",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.135799",
          lon: "-103.790001",
        },
        emission: [],
        id: "8203159b-0a85-4c1e-982f-6031b71de2c5",
        type: "SWD",
        name: "POKER LAKE UNIT 16 BS STATE SWD #001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.18663787",
          lon: "-103.8011515",
        },
        emission: [],
        id: "c85b8945-33b0-4bd5-b8f8-2e7873c0427d",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 196",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.17115461",
          lon: "-103.7851676",
        },
        emission: [],
        id: "a8d48221-419f-41a4-b4b1-92d3cc66e27b",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 197Q",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.066002",
          lon: "-103.845001",
        },
        emission: [],
        id: "71b1f8a9-37be-4f1a-bed6-2ce0ca09e5ec",
        type: "SWD",
        name: "POKER LAKE UNIT 2 TD STATE SWD 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.099998",
          lon: "-103.849998",
        },
        emission: [],
        id: "4414bf1a-f298-4284-832d-faa05b0efe95",
        type: "SWD",
        name: "POKER LAKE UNIT 26 BRIDGE FED SWD 1",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15548097",
          lon: "-103.7844373",
        },
        emission: [],
        id: "6ce709ff-7143-474e-88d7-dd9acc630db5",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT 303 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.2065947",
          lon: "-103.8586214",
        },
        emission: [],
        id: "ca1bfad1-9392-414d-ab57-4a3e286b05ad",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 342 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.13564373",
          lon: "-103.8242695",
        },
        emission: [],
        id: "fd0ea0e3-1616-4cb1-ac38-99c2b99932c6",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 387 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.1926425",
          lon: "-103.7797825",
        },
        emission: [],
        id: "97c6618e-8804-4b4b-a986-626ed749793b",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT 411 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.14702317",
          lon: "-103.8671442",
        },
        emission: [],
        id: "34a36c2a-51f2-4665-8716-f965183e94f4",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 42 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.09559699",
          lon: "-103.7783545",
        },
        emission: [],
        id: "61f0ca1c-a182-4229-a5a9-6964e178f485",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT 420 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.0965945",
          lon: "-103.8631776",
        },
        emission: [],
        id: "65b2332a-8139-441b-a7ce-5abad843ff7c",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 421 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.1127516",
          lon: "-103.9153612",
        },
        emission: [],
        id: "dc115a09-56e8-45ff-af20-26759089eeb9",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 423 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.17965251",
          lon: "-103.8712424",
        },
        emission: [],
        id: "a0d258e8-d788-4f1f-8dd4-5bf08117697e",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 428H BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.19297269",
          lon: "-103.9188701",
        },
        emission: [],
        id: "a71a36ec-68f0-4950-a516-e07138512aba",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT 442/443 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.19387982",
          lon: "-103.8275626",
        },
        emission: [],
        id: "69d4621a-00f9-4235-8a4e-f8b1dd1f2800",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT BATT 078 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.24862022",
          lon: "-103.9179949",
        },
        emission: [],
        id: "22ca4ae3-9f6a-43ec-bdba-194e0a41554a",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT BATT 153",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.23726953",
          lon: "-103.9139245",
        },
        emission: [],
        id: "d243bbab-8647-48ca-8ec2-02605646a9ab",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT BATT 158",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.21242778",
          lon: "-103.9138889",
        },
        emission: [],
        id: "1bc12d76-ba6a-4496-821c-4f22d682a90a",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT BATT 213",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.18181259",
          lon: "-103.9141503",
        },
        emission: [],
        id: "a1299fd8-9b3f-44bc-999b-97bdba39a09c",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT BATT 227",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.20150094",
          lon: "-103.8834712",
        },
        emission: [],
        id: "ca5ba2de-6d17-42c4-85fa-ddce1283c89f",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT BATT 261",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.22589293",
          lon: "-103.9373246",
        },
        emission: [],
        id: "f7ccfbd3-0a2d-4163-846f-6a9990cd0a7a",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT BATT 274",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.24300833",
          lon: "-103.8863111",
        },
        emission: [],
        id: "f66219ea-6d18-41fd-ae2a-dcbd12849821",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT BATT 320",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.20752082",
          lon: "-103.7979934",
        },
        emission: [],
        id: "99d85de1-5eda-45fb-aaea-950f54f14046",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT BATT 68-123-129",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.19003397",
          lon: "-103.8321604",
        },
        emission: [],
        id: "b27c8fbf-022e-4ee6-9aa7-2759406976a7",
        type: "Production_site_with_tank",
        name: "POKER LAKE UNIT METER 089 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.24054393",
          lon: "-103.8555116",
        },
        emission: [],
        id: "47d91152-df0f-4534-aff0-08cefbd4d696",
        type: "Tank_battery_non_satellite",
        name: "POKER LAKE UNIT TBIRD 2 STATE SWD 1 TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.26454302",
          lon: "-103.9348136",
        },
        emission: [],
        id: "a85557d0-07e3-401c-b42e-69da137d03e3",
        type: "Compressor_station",
        name: "RAIDER CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.27695622",
          lon: "-103.9426451",
        },
        emission: [],
        id: "5e8a1ca4-7ccf-459d-89a7-c583e87debf5",
        type: "Tank_battery_non_satellite",
        name: "REMUDA 100 BATTERY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.27051135",
          lon: "-103.9373289",
        },
        emission: [],
        id: "2b9f64f9-ae8a-4f30-9cc6-61c6a73b83f0",
        type: "Tank_battery_non_satellite",
        name: "REMUDA 500 BATTERY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.25553043",
          lon: "-103.9269718",
        },
        emission: [],
        id: "5fa87f84-26ac-4108-882d-64d11cdce7ff",
        type: "Production_site_with_tank",
        name: "REMUDA BASIN `31`ST COM #001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.272314",
          lon: "-103.936131",
        },
        emission: [],
        id: "1643710b-b279-4c1e-931c-fdffb420f3c6",
        type: "SWD",
        name: "REMUDA BASIN 01 SWD",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.28525657",
          lon: "-103.9401269",
        },
        emission: [],
        id: "08afec38-6b3b-44e4-8698-1da7c1d36c51",
        type: "Production_site_with_tank",
        name: "REMUDA BASIN 24 ST BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.27399601",
          lon: "-103.9316972",
        },
        emission: [],
        id: "bdca2404-9cf6-4c4a-94e2-f6c9250dbdee",
        type: "Production_site_with_tank",
        name: "REMUDA BASIN 25 STATE 1 BATT",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.27231391",
          lon: "-103.9361309",
        },
        emission: [],
        id: "a2c1b0c1-9425-4bfe-81ac-96cfcfb08ab6",
        type: "Tank_battery_non_satellite",
        name: "REMUDA BASIN SWD 1",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.28821487",
          lon: "-103.9362193",
        },
        emission: [],
        id: "0f7222e8-4265-410f-9cda-f986213a18ce",
        type: "Production_site_with_tank",
        name: "REMUDA BASIN UNIT BATT 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.01937519",
          lon: "-103.9421473",
        },
        emission: [],
        id: "72d1edad-960e-4d14-b02d-c2f4e8a46151",
        type: "Tank_battery_non_satellite",
        name: "ROSS DRAW 25 NORTHWEST TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.00083902",
          lon: "-103.9152475",
        },
        emission: [],
        id: "27f9d3a1-f495-408b-baba-48b0c3c6d483",
        type: "Tank_battery_non_satellite",
        name: "ROSS DRAW 3031 EAST TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.00231007",
          lon: "-103.9303248",
        },
        emission: [],
        id: "8f128a85-3086-4719-80a2-8316bf9c50b4",
        type: "Tank_battery_non_satellite",
        name: "ROSS DRAW 3031 WEST TB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.00802092",
          lon: "-103.9240525",
        },
        emission: [],
        id: "218f5c7b-df25-423b-9866-1ebe243d23d6",
        type: "Tank_battery_non_satellite",
        name: "ROSS DRAW 30W FEDERAL COM 2",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.017653",
          lon: "-103.942033",
        },
        emission: [],
        id: "139dc95f-617e-4a32-b794-1c9d2e266b87",
        type: "CDP",
        name: "ROSS DRAW GAS CDP",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.00559591",
          lon: "-103.8956581",
        },
        emission: [],
        id: "e8fdb987-f690-4362-91fc-f18d5e4fb180",
        type: "CDP",
        name: "ROSS DRAW OIL CDP",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.00581867",
          lon: "-103.9448569",
        },
        emission: [],
        id: "5b7cffdf-9f11-4be6-8cc2-526c6d00d164",
        type: "Tank_battery_non_satellite",
        name: "ROSS DRAW SOUTH CTB",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.07999999",
          lon: "-103.8961249",
        },
        emission: [],
        id: "b2e4cd1e-ad57-4b50-87e5-d6002be9574d",
        type: "Production_site_with_tank",
        name: "ROSS RANCH 32 STATE BATTERY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.06569223",
          lon: "-103.9183935",
        },
        emission: [],
        id: "7a391aff-9bea-4ef8-ba93-6ef9ef4604a4",
        type: "Production_site_with_tank",
        name: "ROSS RANCH 6 FED BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.15394646",
          lon: "-103.8580863",
        },
        emission: [],
        id: "9047c81e-f89d-497a-ae0f-76ce476d3bc5",
        type: "Production_site_with_tank",
        name: "RUSTLER BLUFF 33/34",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.1539464545",
          lon: "-103.85808625",
        },
        emission: [],
        id: "34e2162f-75db-42da-a293-a51e7d9dfd3b",
        type: "SWD",
        name: "RUSTLER BLUFF 33/34 SWD BATTERY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.53923485",
          lon: "-103.5973604",
        },
        emission: [],
        id: "7dbd8ade-ae31-4659-907c-d34baeb314ac",
        type: "Tank_battery_non_satellite",
        name: "SEVERUS BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.57234346",
          lon: "-103.6152966",
        },
        emission: [],
        id: "f719784d-a551-45a6-a599-182e0959fe7f",
        type: "Tank_battery_non_satellite",
        name: "SHARPNOSE FEDERAL #1 BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.20345721",
          lon: "-103.8379613",
        },
        emission: [],
        id: "31899656-001a-4995-b049-7017f39a86d5",
        type: "Compressor_station",
        name: "SPARTAN CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.09303606",
          lon: "-103.9990557",
        },
        emission: [],
        id: "3af74171-9cab-49a0-a29b-e92037cd7fc5",
        type: "Tank_battery_non_satellite",
        name: "THRILLER/SHOCKER 32 STATE COM #3 BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.11833685",
          lon: "-103.9072855",
        },
        emission: [],
        id: "d92e1f1a-3fb8-42b8-95c3-bbab79c77ac5",
        type: "Compressor_station",
        name: "TIGER CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.51661886",
          lon: "-103.6658614",
        },
        emission: [],
        id: "5d291e80-9a42-4b8b-96d8-919a3a3e404f",
        type: "Production_site_with_tank",
        name: "TORY 3 FEDERAL BATT 1",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.69142238",
          lon: "-104.1411492",
        },
        emission: [],
        id: "25d2ee17-317f-4813-bfa7-e6c44119cd6b",
        type: "Tank_battery_non_satellite",
        name: "TURKEY TR 2 ST COM 001",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.08152694",
          lon: "-103.9900076",
        },
        emission: [],
        id: "e452bbe1-1113-43c8-a1cd-01668eaf1aa0",
        type: "Tank_battery_non_satellite",
        name: "WEST BRUSHY FED 33 #1 BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.06358815",
          lon: "-103.8806114",
        },
        emission: [],
        id: "9f6bec5b-b9be-48f4-bbca-4c169dad75b2",
        type: "CDP",
        name: "WESTERN CDP",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.20206056",
          lon: "-103.7778254",
        },
        emission: [],
        id: "6220637c-09f8-4985-9842-9135f847dace",
        type: "Compressor_station",
        name: "WILDCAT CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.14312522",
          lon: "-103.925168",
        },
        emission: [],
        id: "9cb5a655-e398-4a51-a36e-c720e1fcfb64",
        type: "Compressor_station",
        name: "WOLVERINE CS",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.05325915",
          lon: "-103.9054212",
        },
        emission: [],
        id: "6a0dcb03-902b-4da6-85e3-c0e70c869930",
        type: "Production_site_with_tank",
        name: "YATES FED 8 BTY",
        county: "",
        state: "",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.4490777",
          lon: "-104.0418459",
        },
        emission: [],
        id: "31a1c75c-f319-4ca1-bd4a-6d490d6a7c06",
        type: "Tank_battery_non_satellite",
        name: "Site C",
        county: "John",
        state: "Texas",
        emissionCount: "0",
        fid: null,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.43104345",
          lon: "-104.0942642",
        },
        emission: [],
        id: "9f9c57f2-bb0b-4ee5-8819-24f4c5cc2520",
        type: "Production_site_with_tank",
        name: "Site FID test",
        county: "Harris",
        state: "Texas",
        emissionCount: "0",
        fid: 1,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.4490777",
          lon: "-104.0418459",
        },
        emission: [],
        id: "376eb16d-0cb3-46a1-8236-45a1a9365b37",
        type: "Tank_battery_non_satellite",
        name: "Site B FID test",
        county: "John",
        state: "Texas",
        emissionCount: "0",
        fid: 2,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.44127284",
          lon: "-103.9749366",
        },
        emission: [],
        id: "d69555c8-482a-403b-92bd-11c08c46175a",
        type: "BIG EDDY UNIT #038H",
        name: "Production_site_with_tank1",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 26,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.43808559",
          lon: "-103.9576739",
        },
        emission: [],
        id: "33accd14-0d24-4daa-acf8-4287075fd872",
        type: "BIG EDDY UNIT #097",
        name: "Production_site_with_tank",
        county: "",
        state: "",
        emissionCount: "0",
        fid: 26,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.44127284",
          lon: "-103.9749366",
        },
        emission: [],
        id: "f4774eed-05c5-44ff-be58-1361c85927a9",
        type: "BIG EDDY UNIT #039H",
        name: "Production_site",
        county: "Harris",
        state: "Texas",
        emissionCount: "0",
        fid: 11,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.43808559",
          lon: "-103.9576739",
        },
        emission: [],
        id: "66858748-5f6b-4247-bf18-bbb705ef4b01",
        type: "BIG EDDY UNIT #097A",
        name: "Production_site 1",
        county: "John",
        state: "Texas",
        emissionCount: "0",
        fid: 12,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.44127284",
          lon: "-103.9749366",
        },
        emission: [],
        id: "1d417daa-35e4-40c2-a338-15f6a9a04420",
        type: "BIG EDDY UNIT #039H",
        name: "Site",
        county: "Harris",
        state: "Texas",
        emissionCount: "0",
        fid: 1,
        continuousEmission: false,
      },
      {
        gmap: {
          lat: "32.43808559",
          lon: "-103.9576739",
        },
        emission: [],
        id: "0308a59b-541f-47e6-af9b-96986117156c",
        type: "BIG EDDY UNIT #097A",
        name: "site 1",
        county: "John",
        state: "Texas",
        emissionCount: "0",
        fid: 2,
        continuousEmission: false,
      },
    ],
    id: "bf1b71eb-aaad-4c6e-b818-9ee7c6d74a1e",
    name: "18th July Test",
    date: "2023-07-18T00:00:00Z",
    status: "INPROGRESS",
    surveyTimeZone: "EDT",
  },
];
